import type { LinterResultsData } from './mock';

export function isStyleguideResults(results): results is LinterResultsData['data']['styleguide'] {
  if (!results) return false;
  return 'results' in results && Array.isArray(results.results);
}

export function isStyleguideResult(result): result is LinterResultsData['data']['styleguide']['results'][number] {
  return 'title' in result && 'description' in result && 'score' in result;
}
